import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "status-container" }
const _hoisted_2 = { class: "status-icons" }
const _hoisted_3 = {
  key: 0,
  class: "align-icons"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex gap-1 justify-content-center"
}
const _hoisted_5 = {
  key: 0,
  class: "day-month"
}
const _hoisted_6 = {
  key: 1,
  class: "date-hour"
}
const _hoisted_7 = {
  key: 2,
  class: "d-flex gap-1 justify-content-center style-null-date"
}
const _hoisted_8 = {
  key: 1,
  class: "line"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "status-name" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex gap-1 justify-content-center"
}
const _hoisted_12 = { class: "day-month" }
const _hoisted_13 = { class: "date-hour" }
const _hoisted_14 = {
  key: 1,
  class: "delivery-date"
}
const _hoisted_15 = {
  key: 2,
  style: {"height":"36px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.icons, (index, i) => {
        return _createElementVNode("div", {
          key: $props.basketPlan.getIcon(i).iconName,
          class: "status-icons"
        }, [
          ($setup.props.basketPlan.getStatus() !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode($setup["FontAwesomeIcon"], {
                  style: _normalizeStyle({
              color: $props.basketPlan.getColor(i)
            }),
                  class: _normalizeClass($props.size === 'medium' ? 'icons-medium' : 'icons-small'),
                  icon: $props.basketPlan.getIcon(i)
                }, null, 8 /* PROPS */, ["style", "class", "icon"]),
                ( $props.basketPlan.getTitle(i) && $setup.isVisible)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "title",
                      style: _normalizeStyle({
              color: $props.basketPlan.getColor(i)
            })
                    }, _toDisplayString($props.basketPlan.getTitle(i)), 5 /* TEXT, STYLE */))
                  : _createCommentVNode("v-if", true),
                ($setup.isVisible && i <= $setup.props.basketPlan.getStatus())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      ($props.basketPlan.getDatetoShow(i))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.FormatUtils.humanLocalizedDate($props.basketPlan.getDatetoShow(i) as Date)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      ($props.basketPlan.getDatetoShow(i))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.moment($props.basketPlan.getDatetoShow(i)).format("HH:mm")), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                (i > $setup.props.basketPlan.getStatus() && $setup.isVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("p", null, "- - - -", -1 /* HOISTED */)
                    ]))]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (i < $setup.icons.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
            : _createCommentVNode("v-if", true)
        ])
      }), 64 /* STABLE_FRAGMENT */))
    ]),
    (!$setup.props.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString($setup.props.basketPlan.getStatusName()), 1 /* TEXT */),
          _cache[2] || (_cache[2] = _createElementVNode("div", { style: {"height":"2px"} }, null, -1 /* HOISTED */)),
          ($props.basketPlan.getDatetoShow($setup.props.basketPlan.getStatus()))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString($setup.FormatUtils.humanLocalizedDate( $props.basketPlan.getDatetoShow($setup.props.basketPlan.getStatus()) as Date)), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_13, _toDisplayString($setup.moment($props.basketPlan.getDatetoShow($setup.props.basketPlan.getStatus())).format("HH:mm")), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"height":"16px"} }, null, -1 /* HOISTED */)),
          ( $props.basketPlan.getDeliveryDate() && $setup.props.basketPlan.getStatus() !== $setup.BasketPlanStatus.DELIVERED)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                _cache[1] || (_cache[1] = _createTextVNode(" Previsão de entrega: ")),
                _createElementVNode("b", null, _toDisplayString($setup.FormatUtils.date($props.basketPlan.getDeliveryDate(), false)), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (!( $props.basketPlan.getDeliveryDate() && $setup.props.basketPlan.getStatus() !== $setup.BasketPlanStatus.DELIVERED))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}